import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Đã xóa dòng: import './index.css'; vì bạn không có file này

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
